export default __webpack_public_path__ + "static/media/washupReload2.3372424c.png";